// @flow
import React from 'react'
import FolderTree from './FolderTree'
import styles from './styles.css'
import type { TemplateNode } from 'lib/digital_file/model'

type Props = {
  bordered?: boolean,
  template: Array<TemplateNode>,
  countsByPath: { [path: string]: number },
  selectedPath: ?string,
  onSelect: (path: string) => void,
}

const sumCounts = (
  node: TemplateNode,
  path: string,
  counts: { [path: string]: number },
): number => {
  let total = counts[path] || 0
  for (const child of node.children || []) {
    total += sumCounts(child, `${path}|${child.slug}`, counts)
  }
  return total
}

const FolderRail = ({ bordered = true, template, countsByPath, selectedPath, onSelect }: Props) => {
  const rowClassName = (path: string) => (selectedPath === path ? styles.folderActive : '')

  const renderRight = (path: string, node: TemplateNode, hasChildren: boolean) => {
    const count = hasChildren ? sumCounts(node, path, countsByPath) : countsByPath[path] || 0
    return <span className={styles.count}>{count}</span>
  }

  return (
    <aside className={bordered ? styles.folderRail : styles.folderRailFlat}>
      <div className={styles.railTitle}>
        <span>Folders</span>
      </div>
      <FolderTree
        template={template}
        expandPath={selectedPath}
        rowClassName={rowClassName}
        renderRight={renderRight}
        onLeafClick={onSelect}
      />
    </aside>
  )
}

export default FolderRail
